module.exports = __webpack_public_path__ + "img/carshinaused_22.0b74dced.jpg";